module.exports = __webpack_public_path__ + "static/media/cook.1d5298dc.svg";